module.exports = __webpack_public_path__ + "img/hair_front_female_right_part_mask.75ecc386.png";